
import { fromEventPattern as observableFromEventPattern, Observable } from 'rxjs';

import {share} from 'rxjs/operators';
import { Injectable, Renderer2, inject } from '@angular/core';

@Injectable()
export class GlobalClicks {
  public click$: Observable<MouseEvent>;

  constructor() {
    const renderer = inject(Renderer2);

    const allClicks: Observable<MouseEvent> = observableFromEventPattern(
      (handler: any) => renderer.listen('document', 'click', handler),
      (_handler, detach) => detach()
    );
    this.click$ = allClicks.pipe(share());
  }
}
